/**
 * Una URL de imagen absoluta, para los lugares donde una ruta relativa no sirve.
 *
 * La API resuelve las direcciones de las fotos contra `S3_PUBLIC_BASE_URL`, que **puede ser
 * relativa** (`/media/<bucket>`) cuando un proxy sirve el bucket en el mismo host que el sitio —
 * es la configuración del túnel de la demo, y la que hace que las fotos sobrevivan un cambio de
 * dominio. Para el `<img>` de una página eso está perfecto: el browser la resuelve contra el
 * origen actual.
 *
 * Los scrapers de WhatsApp, Facebook y X no hacen eso: leen el `og:image` del HTML y piden esa
 * cadena tal cual. Con una ruta relativa la preview queda sin foto. Lo mismo el `image` del
 * JSON-LD, que Google usa para los rich results de noticias.
 *
 * El `<head>` es el único lugar del sitio que conoce el origen del request (`ctx.site.url` en el
 * server, `useSitio()` en el cliente), así que es acá donde se absolutiza y en ningún otro lado.
 *
 * Deja intacto lo que ya es absoluto (`http:`, `https:`, `//cdn…`) y los `data:` de los fixtures.
 */
export function absolutizar(siteUrl: string, url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url) || url.startsWith('//')) return url;
  return `${siteUrl.replace(/\/$/, '')}${url.startsWith('/') ? '' : '/'}${url}`;
}
